import React from 'react';

// Reuse the native menu declaration and its existing action handlers. This
// adapter never reimplements account, sharing, delete or navigation behavior.
export function duoMenuItems(children, menu) {
  const text = value => React.Children.toArray(value).map(node => (
    typeof node === 'string' || typeof node === 'number' ? String(node) : React.isValidElement(node) ? text(node.props.children) : ''
  )).join('');
  const part = (children, type) => React.Children.toArray(children).find(node => React.isValidElement(node) && node.type === type);
  return React.Children.toArray(children).flatMap(node => {
    if (!React.isValidElement(node)) return [];
    if (node.type === menu.Trigger) return [];
    if (node.type === menu.Item) return [{
      title: text(part(node.props.children, menu.ItemTitle)?.props.children),
      symbol: part(node.props.children, menu.ItemIcon)?.props.ios?.name,
      disabled: node.props.disabled, destructive: node.props.destructive, onSelect: node.props.onSelect,
    }];
    if (node.type === menu.Sub) {
      const trigger = part(node.props.children, menu.SubTrigger);
      const content = part(node.props.children, menu.SubContent);
      return [{ title: text(part(trigger?.props.children, menu.ItemTitle)?.props.children),
        symbol: part(trigger?.props.children, menu.ItemIcon)?.props.ios?.name,
        disabled: trigger?.props.disabled, children: duoMenuItems(content?.props.children, menu) }];
    }
    return duoMenuItems(node.props.children, menu);
  });
}
